import { IMcpPermission, McpActionEnum } from '@/bundles/Roles/types';

export default class McpPermission implements IMcpPermission {
  id: number;
  name: string;
  action: McpActionEnum;
  resource: string;

  constructor (data: IMcpPermission) {
    this.id = data.id;
    this.name = data.name;
    this.action = data.action;
    this.resource = data.resource;
  }
}
